"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TextDecoration;
(function (TextDecoration) {
    TextDecoration["None"] = "ty-text-dec-none";
    TextDecoration["Underline"] = "ty-text-dec-underline";
    TextDecoration["Overline"] = "ty-text-dec-overline";
    TextDecoration["LineThrough"] = "ty-text-dec-line-through";
    TextDecoration["Initial"] = "ty-text-dec-initial";
    TextDecoration["Inherit"] = "ty-text-dec-inherit";
})(TextDecoration = exports.TextDecoration || (exports.TextDecoration = {}));
